'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestRegisterIfNeeded = exports.failureRegister = exports.receiveRegister = exports.requestRegister = exports.FAILURE_REGISTER = exports.RECEIVE_REGISTER = exports.REQUEST_REGISTER = undefined;

var _css = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _api = require('../api');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_REGISTER = exports.REQUEST_REGISTER = 'REQUEST_REGISTER'; /**
                                                                       * 注册、忘记密码相关Actions
                                                                       */
var RECEIVE_REGISTER = exports.RECEIVE_REGISTER = 'RECEIVE_REGISTER';
var FAILURE_REGISTER = exports.FAILURE_REGISTER = 'FAILURE_REGISTER';

var requestRegister = exports.requestRegister = function requestRegister(profile) {
    return {
        type: REQUEST_REGISTER,
        profile: profile
    };
};

var receiveRegister = exports.receiveRegister = function receiveRegister(profile, json) {
    return {
        type: RECEIVE_REGISTER,
        received_at: Date.now()
    };
};
var failureRegister = exports.failureRegister = function failureRegister(error) {
    var ok = error.ok,
        stack = error.stack,
        _error$status = error.status,
        status = _error$status === undefined ? stack : _error$status,
        statusText = error.statusText,
        type = error.type,
        url = error.url;


    _message2.default.error('\u8BF7\u6C42\u5931\u8D25\uFF1A' + status);
    return {
        type: FAILURE_REGISTER,
        error: { ok: ok, stack: stack, status: status, statusText: statusText, type: type, url: url }
    };
};

var shouldRequestRegister = function shouldRequestRegister(state) {
    var register = state.register;
    if (register.isFetching) {
        return false;
    }
    return true;
};

var requestRegisterIfNeeded = exports.requestRegisterIfNeeded = function requestRegisterIfNeeded(profile) {
    return function (dispatch, getState) {
        if (shouldRequestRegister(getState(), profile)) {
            return dispatch(function (dispatch) {
                dispatch(requestRegister(profile));

                return (0, _api.register)(profile).then(function (response) {
                    if (!response.ok) {
                        return Promise.reject(response);
                    }
                    return response.json();
                }).then(function (json) {
                    return dispatch(receiveRegister(profile, json));
                }).catch(function (error) {
                    dispatch(failureRegister(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/register.js
// module id = 894
// module chunks = 0